<template>
  <div>
    <div class="result-page" :style="{paddingTop: '44px'}">
      <w-navbar nav_title="AI看相" @mobileLeftBtn="goBack"></w-navbar>
      <img src="https://files.wondercv.com/m/ai/home-result-bg.png" class="page-bg" :style="{top: '44px'}"/>
      <div class="header-box">
        <img src="https://files.wondercv.com/m/ai/resulr-title.png" class="title"/>
        <div class="qcode"></div>
      </div>
      <card title="大数据预测">
        <predict :data="{img,level1,level2,level3,top_achievement,face_description}" @on-retry="handleClickRetry"/>
      </card>
      <card title="推荐职位" v-if="jobsList">
        <jobs :data="jobsList"/>
      </card>
      <card title="提高求职成功率50%" long>
        <resume/>
      </card>
      <card title="行业榜样" v-if="industry_role_model">
        <leader :data="industry_role_model"/>
      </card>
      <card title="薪资分布" v-if="stats_salary">
        <salary :data="stats_salary"/>
      </card>
      <div class="bottom-box">
        <div class="btn create" @click="toPng">生成职业卡片</div>
        <div class="btn share" @click="handleClickShare">分享好友</div>
      </div>
    </div>
    <w-share-wx v-show="showShare" @handleClose="showShare = false"/>
    <w-loading :show-text="true" v-show="showLoading"/>
    <input type="file"  accept="image/*"  v-show="false" ref="file" @change="handleSubmit"/>
  </div>
</template>

<script>
  import {loginMixin, envMixin} from "../../assets/js/mixin/global";
  import Card from "./components/Card"
  import Predict from "./components/Predict"
  import Leader from "./components/Leader"
  import Salary from "./components/Salary";
  import Jobs from "./components/Jobs"
  import WNavbar from "../../components/global/w-navbar"
  import Resume from "./components/Resume"
  import WShareWx from "../../components/global/w-share-wx"
  import WLoading from "../../components/global/w-loading"
  import merge from 'webpack-merge';
  export default {
    name: "Ai-Result",
    mixins: [loginMixin, envMixin],
    components: {Card, Predict, Leader, Salary, Jobs, Resume, WNavbar, WShareWx, WLoading},
    data(){
      return{
        img:"",
        level1: "",
        level2: "",
        level3: "",
        top_achievement: "",
        face_description: "",
        industry_role_model: null,
        stats_salary: null,
        jobsList: null,
        url: "",
        showShare: false,
        showLoading: false,

      }
    },
    mounted() {
      setTimeout(()=>{
        this.$route.meta.shareByWx('和上千万求职者形象匹配', { title: '不知道自己适合做什么？试试大数据看相！', imgUrl: 'https://files.wondercv.com/m/ai/logo.png' },process.env.VUE_APP_HOST + '/ai/faces')
      },1000)
      this.initData()
    },
    methods:{
      initData() {
        try {
          let obj = window.sessionStorage.getItem("aiData")
          if(!obj){
            this.goBack()
            return
          }
          let {face_description, level1, level2, level3, top_achievement,industry_role_model, salary_distribution_data, jobsList, img} = JSON.parse(obj)
          this.level1 = level1
          this.level2 = level2
          this.level3 = level3
          this.top_achievement = top_achievement
          this.face_description = face_description
          this.industry_role_model = industry_role_model
          this.stats_salary = salary_distribution_data
          this.jobsList = jobsList
          this.img = img
        } catch (e) {
          alert(e)
        }
      },
      toPng() {
        let obj = window.sessionStorage.getItem("aiData")
        this.$router.push({name: 'ai-share', params: JSON.parse(obj)})
      },
      handleClickShare() {
        this.showShare = true
      },
      handleClickRetry() {
        this.$refs.file.click()
      },
      async handleSubmit(e) {
        let file = e.target.files[0]
        let params = new FormData();
        params.append('file',file)
        this.showLoading = true
        let firstUse = window.localStorage.getItem("first-use")
        let profession_ids = []
        if(!firstUse) {
          let intentions = await this.$api.intention.getIntentionNew()
          if(intentions.code === 1000){
            profession_ids = intentions.data.profession_ids
            window.localStorage.setItem("first-use", 'true')
          }
        }
        this.$api.ai.getAiFaces(params).then(res=>{
          if(res.code === 1000){
            if(profession_ids.length === 0){
              profession_ids =  res.data.profession_id
            }
            this.$api.ai.getAiFacesReport({profession_ids, salary_id: res.data.salary_id || ''}).then(res1=>{
              if (res1.code === 1000){
                let {face_description, level1, level2, level3, top_achievement,industry_role_model, salary_distribution_data} = res1.data
                this.$api.HrApi.getJobListBySearch({from: 0, size: 3, jdflag: 2 ,keyword:level3 || level2 || level1 }).then(res2=>{
                  if(res2.code === 1000){
                    this.showLoading = false
                    this.$refs.file.value = ""
                    this.level1 = level1
                    this.level2 = level2
                    this.level3 = level3
                    this.top_achievement = top_achievement
                    this.face_description = face_description
                    this.industry_role_model = industry_role_model
                    this.stats_salary = salary_distribution_data
                    this.jobsList = res2.data.jobs
                    this.img = res.data.img
                    window.sessionStorage.setItem("aiData",JSON.stringify({...res1.data, jobsList: res2.data.jobs, img: res.data.img}))
                  } else {
                    this.showLoading = false
                    this.$createToast({
                      time: 3000,
                      type: 'txt',
                      txt: res2.message || res2.msg
                    }).show()
                  }
                })
              } else {
                this.showLoading = false
                this.$createToast({
                  time: 3000,
                  type: 'txt',
                  txt: res1.message || res1.msg
                }).show()
              }
            })
          }else{
            this.showLoading = false
            this.$createToast({
              time: 3000,
              type: 'txt',
              txt: res.message || res.msg
            }).show()
          }
        }).catch(err=>{
          this.showLoading = false
          this.$createToast({
            time: 3000,
            type: 'txt',
            txt: '服务器正在开小差，请稍后重试！！！'
          }).show()
        })
      },
      goBack() {
        window.location.replace('/ai/faces')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/scss/global/mixin';
.result-page{
  background: #190647;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  z-index: 10;
  padding-bottom: 80px;
  .page-bg{
    position: absolute;
    width: 100%;

  }
  .header-box{
    position: relative;
    display: flex;
    z-index: 2;
    padding-left: 18px;
    padding-top: 25px;
    margin-bottom: 23px;
    .title{
      width: 244px;
      height: 68px;
      margin-top: 5px;
      margin-right: 23px;
    }
    .qcode{
      width: 60px;
      height: 60px;
      background: url("https://files.wondercv.com//m/ai/result-code.png");
      background-size: 100%;
      position: relative;
      &::after{
        content: "扫码回复【测试】";
        position: absolute;
        left: -15px;
        bottom: -16px;
        font-size: 12px;
        color: #D5C3FF;
        width: 100px;
        transform: scale(0.75);
      }
    }
  }
  .bottom-box{
    height: 60px;
    padding: 8px 20px;
    @include ipx-footer(60px, 8px);
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 20;
  }
  .btn{
    width: 160px;
    height: 44px;
    border-radius: 22px;
    box-sizing: border-box;
    text-align: center;
    line-height: 44px;
  }
  .create{
    border: 1px solid #8A5DF9;
    color: #8A5DF9;
  }
  .share{
    background: linear-gradient(360deg, #8F61FF 0%, #8C98FF 100%);
    color: #fff;
  }
}
.dom-box{
  position: absolute;
  top: 0;
  z-index: 0;

}
</style>
